import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TextInput from '../inputs/TextInput';
import Button from '../buttons/Button';
import RadioGroup from '../inputs/RadioGroup';
import ErrorMessage from '../message/ErrorMessage';
import { postTeam } from '../../api/cloudApiGenerated';

class TeamModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.createNewTeam = this.createNewTeam.bind(this);

    this.state = {
      name: '',
      options: [
        { name: '0', value: 'Public' },
        { name: '1', value: 'Private' },
      ],
      selectValue: '0',
      newTeamError: '',
    };
  }

  onSearchInputChange(event) {
    this.setState({
      name: event.target.value,
    });
  }

  createNewTeam() {
    if (this.state.name === '') {
      this.setState({ newTeamError: 'A team name is mandatory.' });
      return;
    }
    postTeam({ name: this.state.name, private: this.state.selectValue }).then(() => {
      this.props.reloadTeams(true);
      this.props.close();
    });
  }

  onChange(element) {
    this.setState({ selectValue: element });
  }

  render() {
    return (
      <Modal
        className="hc-modal-content new-team-modal"
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        parentSelector={this.props.parentSelector}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.close}
        contentLabel="New Team"
      >
        <ErrorMessage error={this.state.newTeamError} />
        <h3>Create new team</h3>
        <p className="">
          {' '}
          This will create a new organization with a new subscription. Any charts you create in this team cannot be
          transferred over to another team. If this does not sound like what you need, you may be looking to create a
          new subteam instead.
        </p>
        <div>
          <label htmlFor="name"> Name: </label>
        </div>
        <TextInput
          name="name"
          value={this.state.name}
          onChange={this.onSearchInputChange}
          placeholder="Name"
          autoFocus={true}
        />
        <div className="radio-container">
          <RadioGroup
            options={this.state.options}
            groupName="private"
            checked={this.state.selectValue}
            onSelect={this.onChange}
          />
        </div>
        <br />
        <Button buttonText="Add" buttonClass="bulk-action-btn" onClick={this.createNewTeam} />{' '}
        <Button buttonText="Cancel" buttonClass="bulk-action-btn grey" onClick={this.props.close} />
      </Modal>
    );
  }
}

TeamModal.propTypes = {
  isOpen: PropTypes.bool,
  parentSelector: PropTypes.func,
  close: PropTypes.func,
  reloadTeams: PropTypes.func,
};

export default TeamModal;
